import {
    FETCH_LOYALTY_PROGRAM_MEMBERS,
    ADD_MEMBER_TO_LOYALTY_PROGRAM,
    REMOVE_MEMBER_FROM_LOYALTY_PROGRAM,
} from '../../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_LOYALTY_PROGRAM_MEMBERS:
            return action.payload;
        case ADD_MEMBER_TO_LOYALTY_PROGRAM:
            return state.concat(action.payload);
        case REMOVE_MEMBER_FROM_LOYALTY_PROGRAM:
            return state.filter(member => member.id !== action.payload.memberId);
        default:
            return state;
    }
};
